import IApplicationLanding from '@sunbit-dev/common/models/cardApply/IApplicationLanding';
import { Actions, ActionTypes } from '../actions/applicationLandingActions';

export interface IApplicationLandingState extends Partial<IApplicationLanding> {
  type?: ActionTypes;
}

const initialState: IApplicationLandingState = {
}

export default function applicationLandingReducer(state = initialState, action: Actions): IApplicationLandingState {
  switch(action.type) {
    case ActionTypes.Init:
      return {...state, ...action};
    case ActionTypes.getLandingDetails:
      return {...state, ...action};      
    default:
      return state;
  }
}
